import type { ReportDashboardComponentGridPosition } from './report-component.types';
import type { ReportDashboard } from './report-dashboards.types';
import type { ReportDashboardLibraryComponent } from './report-library.types';

export type ReportDashboardTemplateComponent = ReportDashboardLibraryComponent & {
  localId: string;
  templateId: string;
  verticalGrid: ReportDashboardComponentGridPosition;
};

export enum ReportDashboardTemplateId {
  Candidates = 'candidates',
  Jobs = 'jobs',
  Pipelines = 'pipelines',
  Disqualifications = 'disqualifications',
  Hires = 'hires',
  CareerSites = 'carrer_sites',
  Interviews = 'interviews',
  Evaluations = 'evaluations',
  CandidateOverview = 'candidate_overview',
  PipelineInsights = 'pipeline-insights',
  CandidateDisqualifications = 'candidate_disqualifications',
  JobOverview = 'job_overview',
  EventsAndEvaluations = 'events_and_evaluations',
}

export type ReportDashboardTemplatesResponse = {
  dashboardTemplates: ReportDashboardTemplateApiEntity[];
  references: unknown[];
};

export type ReportDashboardTemplateApiEntity = Omit<
  ReportDashboardTemplate,
  'gridPositions' | 'componentIds'
> & {
  components: ReportDashboardTemplateComponent[];
};

export type ReportDashboardTemplate = Omit<
  ReportDashboard,
  'id' | 'dateFilter' | 'position' | 'componentIds' | 'components'
> & {
  id: `${ReportDashboardTemplateId}`;
  description: string;
  // FE only
  componentIds: string[];
  // FE Only
  // Keep dictionary of positions for each component
  gridPositions: Record<string, ReportDashboardComponentGridPosition>;
  verticalGridPositions: Record<string, ReportDashboardComponentGridPosition>;
};
